/* eslint-disable indent */
import { serviceName } from './serviceConstants';

/**
 * Appends the service name to the URL based on the given service.
 *
 * @param {string} service - The service name.
 * @returns {string} The URL with the service name appended.
 */
export const appendServiceNameToURL = (service) => {
  return `/${service.toLowerCase()}-service`;
};

/**
 * Appends the service port to the URL based on the provided service name.
 *
 * @param {string} service - The name of the service.
 * @returns {number} - The port number associated with the service.
 */
export const appendServicePortToURL = (service) => {
  const portMap = {
    [serviceName.LANDING_MS]: 3001,
    [serviceName.ROLES_MS]: 3002,
    [serviceName.CERTIFICATIONS_MS]: 3003,
    [serviceName.SKILLS_MS]: 3004,
    [serviceName.COMMON_MS]: 3005,
    [serviceName.MASTER_MS]: 3007,
    [serviceName.USER_ROLES_MS]: 3008,
    [serviceName.INTEGRATION_MS]: 3009,
    [serviceName.ACHIEVEMENTS_MS]: 3010,
    [serviceName.PERFORMANCE_MS]: 3011,
    [serviceName.DARPAN_BRIDGE_MS]: 3012,
    [serviceName.DEAL_TRANSITION_MS]: 3013,
    [serviceName.PROJECT_MS]: 3014,
    [serviceName.STAFF_AUGMENTATION_MS]: 3015,
  };

  return portMap[service];
};
